import type { WithActiveBranchId } from '@app/api/shared';

export enum MigrationEndpoints {
  GetMigrationsYClients = 'GetMigrationsYClients',
  GetMigrationYClients = 'GetMigrationYClients',
  CreateMigrationYClients = 'CreateMigrationYClients',
  UpdateStatusMigrationYClients = 'UpdateStatusMigrationYClients',
}

export enum MigrationStatus {
  Waited = 'Waited',
  Stopped = 'Stopped',
  Running = 'Running',
  Successed = 'Successed',
  Failed = 'Failed',
}

export enum EnumMigrationStep {
  Positions = 'Positions',
  CategoryServices = 'CategoryServices',
  Services = 'Services',
  // В легаси-константах значение было 'Empoyees' («точь-в-точь как возвращает
  // сервер»); актуальный swagger отдаёт 'Employees'. Значение нигде не
  // сравнивается в рантайме — следуем контракту.
  Employees = 'Employees',
  Clients = 'Clients',
  Records = 'Records',
}

export interface ModelMigrationYClients {
  LegalEntityId: number;
  ApiToken?: string | null;
  Login?: string | null;
  Password?: string | null;
}

export interface ModelDataMigrationStep {
  Status: MigrationStatus;
  Step: EnumMigrationStep;
}

export interface ModelDataMigrationBranch {
  BranchId: number;
  Name?: string | null;
  Steps?: ModelDataMigrationStep[] | null;
}

export interface ModelDataMigrationChain {
  ChainId: number;
  Name?: string | null;
  Branches?: ModelDataMigrationBranch[] | null;
}

export interface ModelDataMigrationStatus {
  Chains?: ModelDataMigrationChain[] | null;
}

export interface ModelDataMigration {
  LegalEntityId: number;
  LegalEntity?: string | null;
  CreateUser?: string | null;
  TimeCreated: string;
  TimeStarted?: string | null;
  TimeEnded?: string | null;
  Status: MigrationStatus;
  Login?: string | null;
  Data: ModelDataMigrationStatus;
}

export type GetMigrationsYClientsRequest = WithActiveBranchId;

export type GetMigrationYClientsRequest = WithActiveBranchId<{
  legalEntityId: number;
}>;

export type CreateMigrationYClientsRequest = WithActiveBranchId<{
  data: ModelMigrationYClients;
}>;

export type UpdateStatusMigrationYClientsRequest = WithActiveBranchId<{
  legalEntityId: number;
  status: MigrationStatus;
}>;

export type GetMigrationsYClientsResponse = ModelDataMigration[];
export type GetMigrationYClientsResponse = ModelDataMigration;
export type CreateMigrationYClientsResponse = void;
export type UpdateStatusMigrationYClientsResponse = void;
